export default "__VITE_ASSET__Bg4h1ssd__"